export default __webpack_public_path__ + "static/SRI 4560PW - Product Specifications & Technical Data-a34461c07fce415d7962315497199b5d.pdf";